<script lang="ts">
  import type { HTMLTextareaAttributes } from 'svelte/elements';
  import { cn } from '../lib/cn';
  import { controlClass } from './form';

  let { class: className, rows = 3, value = $bindable(), ...rest }: HTMLTextareaAttributes = $props();
</script>

<textarea {rows} bind:value class={cn(controlClass, 'py-2.5', className as string | undefined)} {...rest}></textarea>
